/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@material-ui/core';
import DeleteButton from '../../components/Buttons/DeleteButton';
import { DateHelper } from '../../helpers/DateHelper';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import FetaureUsage from './FetaureUsage';

class FeaturesRow extends PureComponent {
    deleteComponentCallback = (params) => {
        this.props.deleteFeature(params);
    };

    render() {
        const { feature, classes } = this.props;
        const tableCellRoot = { root: classes.tableCellRoot };
        const allowDelete = !UserRoleHelper.checkRole(roles.ROLE_PLATFORM_SIMCARD_SERVICE_POST);
        return (
            <React.Fragment>
                <TableRow hover={true}>
                    <TableCell classes={tableCellRoot} padding="none" align="left">
                        {feature.simCardServiceType.mainname}
                    </TableCell>
                    <TableCell classes={tableCellRoot} padding="none" align="left">
                        {feature.simCardServiceType.description}
                    </TableCell>
                    <TableCell classes={tableCellRoot} padding="none" align="left">
                        {DateHelper.format(feature.activatedAt)}
                    </TableCell>
                    <TableCell classes={tableCellRoot} padding="none" align="right">
                        {
                            <DeleteButton
                                disabled={allowDelete}
                                callback={this.deleteComponentCallback}
                                callbackParam={{
                                    uri: feature['@id'],
                                    componentName: feature.simCardServiceType.mainname,
                                    simCardId: feature.simCardId,
                                    status: 0,
                                }}
                            />
                        }
                    </TableCell>
                </TableRow>
                <FetaureUsage params={feature.servicesParams} />
            </React.Fragment>
        );
    }
}

FeaturesRow.propTypes = {
    classes: PropTypes.object.isRequired,
    feature: PropTypes.object.isRequired,
};

export default withStyles(adescomStyle)(FeaturesRow);
